function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M290.4 29.9l-168 199.3c-15.6 18.7-9.4 57.5 15.6 58.5l81.4 4.1-71 159.8c-30.2 67.8 7.3 78.3 57.5 23l187.9-207.7c16.7-18.7 9.4-56.3-14.6-57.5l-84.6-5.2 54.2-153.3c19.9-58.6-17.7-68-58.4-21z"
}));